
import {NgModule} from '@angular/core';
import { DatepickerRangeComponent } from './datepicker-range/datepicker-range.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { InputComponent } from './input/input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PopoverComponent } from './popover/popover.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { SelectComponent } from './select/select.component';
import { TypeaheadComponent } from './typeahead/typeahead.component';
defineLocale('es', esLocale);

@NgModule({
    declarations: [
        DatepickerRangeComponent,
        DatepickerComponent,
        InputComponent,
        PopoverComponent,
        SelectComponent,
        TypeaheadComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true
        }),
        TooltipModule.forRoot(),
        BsDatepickerModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
    ],
    exports:[
        DatepickerRangeComponent,
        DatepickerComponent,
        InputComponent,        
        PopoverComponent,
        SelectComponent,
        TypeaheadComponent
    ],
    providers: [
    ],
    bootstrap: []
})
export class FormsToolsModule {}
